import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileInfo: {},
  propertyUnit: {},
  leaseDetails: {
    monthlyCharges: [],
  },
  tenantId: "",
  leaseId: "",
};

export const moveInTenantSlice = createSlice({
  name: "moveInTenant",
  initialState,
  reducers: {
    setProfileInformation: (state, action) => {
      state.profileInfo = action.payload;
    },
    setPropertyUnitInformation: (state, action) => {
      state.propertyUnit = action.payload;
    },
    setTenantsInformation: (state, action) => {
      state.tenants = action.payload.tenants;
    },
    setPropfileInfo: (state, action) => {
      state.profileInfo = action.payload;
    },
    setAdditionalTenants: (state, action) => {
      state.additionalTenants = action.payload;
    },
    setLeaseDetails: (state, action) => {
      state.leaseDetails = action.payload;
    },
    setLeaseFinish: (state, action) => {
      state.leaseFinish = action.payload;
    },
    setGenerateLease: (state, action) => {
      state.generateLease = action.payload;
    },
    setTenantData: (state, action) => {
      state.tenantId = action.payload;
    },
    setLeaseId: (state, action) => {
      state.leaseId = action.payload;
    },
  },
});

export const SelectMoveInTenantInfo = (state) => state.moveInTenant;
export const SelectProfileInfo = (state) => state.moveInTenant.profileInfo;
export const selectAdditionalTenants = (state) => state.moveInTenant.additionalTenants;

export const {
  setProfileInformation,
  setPropertyUnitInformation,
  setTenantsInformation,
  setPropfileInfo,
  setAdditionalTenants,
  setLeaseDetails,
  setGenerateLease,
  setLeaseFinish,
  setTenantData,
  setLeaseId,
} = moveInTenantSlice.actions;

export default moveInTenantSlice.reducer;
